import createLocalSeedBackupsAtom from './local-seed-backups.js'
import createLocalSeedBackupMaxAgeAtom from './local-seed-backup-max-age.js'
import createLocalSeedPrivateBackupsAtom from './local-seed-private-backups.js'

export const localSeedPrivateBackupsAtomDefinition = {
  id: 'localSeedPrivateBackupsAtom',
  type: 'atom',
  factory: createLocalSeedPrivateBackupsAtom,
  dependencies: ['keystore'],
  public: false,
}

export const localSeedBackupsAtomDefinition = {
  id: 'localSeedBackupsAtom',
  type: 'atom',
  factory: createLocalSeedBackupsAtom,
  dependencies: ['wallet', 'localSeedPrivateBackupsAtom'],
  public: false,
}

export const localSeedBackupMaxAgeAtomDefinition = {
  id: 'localSeedBackupMaxAgeAtom',
  type: 'atom',
  factory: createLocalSeedBackupMaxAgeAtom,
  dependencies: ['storage', 'config'],
  public: false,
}
